import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getScholarSubjectsRequest } from "lib/api/reference/scholarSubject";
import type { ScholarSubjectInterface } from "types/reference";

export const scholarSubjectReferenceKeys = {
    all: ["reference", "scholar-subject"] as const,
    list: (languageCode: string) => [...scholarSubjectReferenceKeys.all, "list", languageCode] as const,
};

export const fetchScholarSubjects = (languageCode: string) =>
    parseResponse<Array<ScholarSubjectInterface>>(getScholarSubjectsRequest(languageCode));

export const scholarSubjectReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<ScholarSubjectInterface>>({
        queryKey: scholarSubjectReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchScholarSubjects(languageCode),
        enabled: Boolean(languageCode),
    });

export const useScholarSubjects = (languageCode: string) =>
    useQuery(scholarSubjectReferenceQueryOptions(languageCode));
